function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import { highlightedHourlyRecordsShape } from 'shapes/bins';
import App from 'modules/App';
import AmbulatoryGlucoseProfile from 'modules/AmbulatoryGlucoseProfile';
import messages from 'modules/AmbulatoryGlucoseProfile/messages';
import * as patientResultsConstants from 'modules/PatientResults/constants';
import BloodGlucoseProfileAgpReportChart from 'components/Charts/BloodGlucoseProfileAgpChart/BloodGlucoseProfileAgpReportChart';
import SectionTitle from '../components/SectionTitle';
import styles from './AgpSection.pcss';
var _React_Component;
class AgpSection extends (_React_Component = React.Component) {
    render() {
        const { conversion, standards, highlightedHourlyRecords, direction, readingsCount, maxValue } = this.props;
        const showModalDay = readingsCount < patientResultsConstants.READING_COUNT_TO_SHOW_AGP_BGM;
        const title = showModalDay ? messages.headers.bgmModalDay : messages.headers.ambulatoryGlucoseProfile;
        const info = showModalDay ? messages.labels.insufficiencyInfo : messages.labels.agpBgmChartInfo;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.agpSectionWrapper,
            children: [
                /*#__PURE__*/ _jsx(SectionTitle, {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, title))
                }),
                /*#__PURE__*/ _jsx("h2", {
                    className: styles.agpChartInfo,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, info))
                }),
                /*#__PURE__*/ _jsx(BloodGlucoseProfileAgpReportChart, {
                    conversion: conversion,
                    standards: standards,
                    highlightedHourlyRecords: highlightedHourlyRecords,
                    direction: direction,
                    showModalDay: showModalDay,
                    maxValue: maxValue
                })
            ]
        });
    }
}
_define_property(AgpSection, "propTypes", {
    // Explicit props
    conversion: PropTypes.object.isRequired,
    statistics: PropTypes.shape({
        veryHigh: PropTypes.number,
        high: PropTypes.number,
        target: PropTypes.number,
        low: PropTypes.number,
        veryLow: PropTypes.number
    }),
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    readingsCount: PropTypes.number,
    maxValue: PropTypes.number,
    // Implicit props
    highlightedHourlyRecords: highlightedHourlyRecordsShape,
    direction: PropTypes.string
});
const mapStateToProps = (state)=>({
        highlightedHourlyRecords: AmbulatoryGlucoseProfile.selectors.highlightedHourlyRecords(state),
        direction: App.selectors.direction(state)
    });
const ConnectedAgpSection = connect(mapStateToProps)(AgpSection);
export default withStyles(styles)(ConnectedAgpSection);
